import { PageErrorCode } from './PageErrorCode'
import { PageErrorLogo } from './PageErrorLogo'
import { PageErrorTitle } from './PageErrorTitle'

export const PageError = {
  Logo: PageErrorLogo,
  Title: PageErrorTitle,
  Code: PageErrorCode,
}
